module.exports = require("ramda/src/tap");